<template src="./UserManagement.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("userManagement");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import router from '@/router/index';

export default {
  components: {
    DialogBox,
    ViewDropdown,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 150,
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      defaultVal: { name: "All", id: "All" },
      searchText: "",
      add: true,
      sort: [{ field: "vehicleRtoNum", dir: "asc" }],
      viewColumns: [],
      columns: [
        {
          hidden: false,
          field: "name",
          title: "Name",
          width: "150px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          title: "Email",
          field: "email",
           width: "250px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          title: "Contact Number",
          field: "mobileNo",
          width: "130px",
          checked: true,
          defaultSelected: false,
        },
        {
          hidden: false,
          title: "Roles",
          field: "userRole",
          cell: this.cellFunction,
          checked: true,
          width: "180px",
          defaultSelected: false,
        },

        {
          hidden: false,
          cell: CommandCell,
          title: "Actions",
          width: "150px",
          locked: true,
          ignoreCheckbox: true,
        },
      ],
      dataItems: [],
      allowVendor: false,
      //  defaultVal: { name: 'All', id: 'all'},
    };
  },
  props: {
    selectedVehicleColumns: Array,
  },
  methods: {
    cellFunction: function (h, tdElement, props) {
      const field = props.field;
      const array = props.dataItem[field];
      const roleNames = array.map((a) => a.roleName);
      return h("td", {}, roleNames.join(','));
    },
    openWindow: function () {
      this.$router.push({ name: "user-management-add", params: { } });
      // this.$router.push("/vehicle-management/add");
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },

    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function () {
      this.add = true;
    },
    remove: function (item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    downloadTemplate() {
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("userManagement/removeUser", item.dataItem.id)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
        })
        .catch(notifyApiError);
    },
    edit: function (item) {
      router.push({ name: "user-management-add", params: { ...item,  update: true, } });
    },
    async getDataOnload() {
      // if (!this.$route.params.cancel) { }
      // this.$store.dispatch('userManagement/getUserRoles');
    },
    columnChange(e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      this.$store.commit("userManagement/setVehicleSpeedLimitColumns", [
        ...this.columns,
      ]);
      localStorage.setItem(
        "vehicleManagementColumns",
        JSON.stringify(this.viewColumns)
      );
    },
    ...mapActions([""]),
    Search() {
      console.log(this.items);
      this.vehicleData = [];
    },
  },
  computed: {
    ...mapState({
      vehicleData: (state) => state.vehicleData,
      loader: (state) => state.loader
    }),
    ...mapGetters([
      "getUserRoles"
    ]),
    total() {
      return this.$store.getters['userManagement/getUsers'].length;
    },
    filter() {
      return {
        logic: "or",
        filters: [
          {
            field: "name",
            operator: "contains",
            value: this.searchText,
          },
          {
            field: "email",
            operator: "contains",
            value: this.searchText,
          },
        ],
      };
    },
    items: {
      get: function () {
        const text = this.searchText.toLowerCase();
        return orderBy(
          this.$store.getters['userManagement/getUsers']
          .filter((user) => (
            user.name + 
            user.mobileNo + " "
            + user.email ).toLowerCase(text))
          .slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
  mounted() {
    this.getDataOnload();

    const eListColumns = JSON.parse(
      localStorage.getItem("vehicleManagementColumns")
    );
    if (!eListColumns) {
      this.viewColumns = [...this.columns];
      this.$store.commit("vehicle/setSelectedVehicleColumns", [
        ...this.columns,
      ]);
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
              defaultSelected: obj.defaultSelected,
              ignoreCheckbox: obj.ignoreCheckbox,
            });
          } else {
            items.push({ ...col });
          }
      });

      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.viewColumns = items;
      this.columns = items;
      this.$store.commit("vehicle/setSelectedVehicleColumns", items);
    }
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
      if (mutation.type == "setInitialData") {
        this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  beforeMount() {},
};
</script>

<style lang="scss" scoped>
.search_mobile{width: 15% !important; border-radius: 5px;}
@media only screen and (max-width: 768px) {
  .search_mobile{width: 40% !important;}
  .driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
  .page-header .title-text {font-size: 12px;}  
}
</style>
